import React from "react";
import style from "./Toast.module.css";
import { NotificationContext } from "../context/NotificationProvider";

function Toast() {
  const { messages } = React.useContext(NotificationContext);
  return (
    <div className={style.toasts}>
      {messages.map((message) => (
        <div key={message.id} className={`${style.toast} ${message.className}`}>
          {message.message}
        </div>
      ))}
    </div>
  );
}

export default Toast;
